import { createContext, useContext, useEffect, useState } from 'react';
import jwtDecode from 'jwt-decode';
import { toast } from 'react-toastify';
import axios from '../api/axios'; // your axios instance with baseURL

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [menus, setMenus] = useState([]);
  const [loadingMenus, setLoadingMenus] = useState(true);

  // Auto-load on mount
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;

    try {
      const decoded = jwtDecode(token);
      if (decoded?.id) {
        setUser(decoded);
        const cachedMenus = localStorage.getItem(`menus_${decoded.id}`);
        if (cachedMenus) {
          setMenus(JSON.parse(cachedMenus));
          setLoadingMenus(false);
        } else {
          fetchMenus(decoded.id);
        }
      }
    } catch (err) {
      toast.error('Invalid token');
    }
  }, []);

  const fetchMenus = async (userId) => {
    try {
      const res = await axios.get(`/users/${userId}/menus`);
      setMenus(res.data);
      localStorage.setItem(`menus_${userId}`, JSON.stringify(res.data));
    } catch (err) {
      console.error('Failed to load user menus', err);
      toast.error('Unable to load menu permissions');
    } finally {
      setLoadingMenus(false);
    }
  };

  const login = (token) => {
    try {
      const decoded = jwtDecode(token);
      if (decoded && decoded.id) {
        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(decoded));
        setUser(decoded);
        fetchMenus(decoded.id);
      } else {
        throw new Error('Decoded token invalid');
      }
    } catch (err) {
      toast.error('Login failed: Invalid token');
    }
  };

  const logout = () => {
    localStorage.removeItem(`menus_${user?.id}`);
    localStorage.clear();
    setUser(null);
    setMenus([]);
    toast.success('Logged out successfully');
  };

  return (
    <AuthContext.Provider value={{ user, menus, loadingMenus, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);